import { render, staticRenderFns } from "./VitaminFactorBandEdit.vue?vue&type=template&id=77e9d943&scoped=true"
import script from "./VitaminFactorBandEdit.vue?vue&type=script&lang=js"
export * from "./VitaminFactorBandEdit.vue?vue&type=script&lang=js"
import style0 from "./VitaminFactorBandEdit.vue?vue&type=style&index=0&id=77e9d943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e9d943",
  null
  
)

export default component.exports